import Text from 'core-system/Text'
import palette from 'core-system/Themes/palette'
import React from 'react'

const CommuterSupport = () => (
  <Text variant='body2' textColor={palette.text.secondary}>
    No tickets for this employee
  </Text>
)

export default CommuterSupport
